// extracted by mini-css-extract-plugin
module.exports = {"timeDate":"MessageSent_timeDate__q2SkL","sentMessage":"MessageSent_sentMessage__32f_h","outgoingMessage":"MessageSent_outgoingMessage__3aNTY"};